// src/mocks/handlers/runningAccount.handlers.js
import * as data from '../data/runningAccount.demo';

export const handle = async (config) => {
    if (config.method === 'post')  return { success: true, data: {} };
    if (config.method === 'patch') return { success: true };
    if (/\/runningaccount\/statistics/.test(config.url)) return data.aggregateStats;
    if (/\/runningaccount\/clients/.test(config.url))    return { clients: [] };
    return { success: true, movements: [], pagination: { totalRecords: 0 } };
};
